<template>
  <div>
    
    
    <div class="login-btn" v-if="styleType=='bar'" @click.stop="facebookLogin()">
        <img class="login_icon" src="../../../assets/img/h5_login_fb.png" />
        <span>{{$t('m.log_in_using_Facebook')}}</span>
    </div>
    <div class="img_box" v-else @click.stop="facebookLogin()">
      <img class="login_other_img" src="../../../assets/img/h5_login_icon12.png" />
    </div>
    
  </div>


  
</template>
<script>
import Vue from 'vue'
import {Dialog, Toast} from "vant";
// import FBSignInButton from 'vue-facebook-signin-button'
// Vue.use(FBSignInButton)
import { myMixin } from "@/tools/mixins.js";
Vue.use(Dialog);
var _self;
export default {
  name: "LoginFacebook",
  mixins: [myMixin],
  props: {
    styleType: {
      type: String,
      default: 'bar'//bar 长条状 circle 其他方式圆形状
    }
  },
  data() {
    return {
       fbSignInParams: {
          scope: 'email',
          return_scopes: true
        },
        authResponse:{},
        sdkSuccess:false,//fb sdk 是否成功加载过了
    };
  },
  computed: {},
  mounted() {
    _self = this;
    this.initFacebook();
    // _self.loadFacebookSDK();
  },
  methods: {
    loadFacebookSDK(success,failed) {
      // 动态加载 Facebook SDK
      var js = document.createElement('script');
      js.id = 'facebook-jssdk';
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      // 监听 SDK 加载失败的情况
      js.onerror = function() {
        console.log('Failed to load Facebook SDK');
        _self.sdkSuccess = false;
        failed&&failed();
      };
      // 监听 SDK 加载成功的情况
      js.onload = function() {
        console.log('Facebook SDK loaded successfully');
        _self.sdkSuccess = true;
        success&&success();
      };
      // fjs.parentNode.insertBefore(js, fjs);
      document.getElementsByTagName('head')[0].appendChild(js);
    },
    // 初始化
    initFacebook() {
      // 初始化 Facebook SDK
      window.fbAsyncInit = function() {
        window.FB.init({
          appId: '559753921074292',
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v25.0'
        });
      };      
		},
    facebookLogin(){
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/android/i)&&ua.match(/build\//i)) {
        Dialog.alert({
          title: _self.$i18n.t('m.friendly_tip'),
          message: _self.$i18n.t('m.android_fblogin_tip'),
          confirmButtonText:_self.$i18n.t('m.i_got_it'),
          theme: 'round-button',
          closeOnClickOverlay:true,
          confirmButtonColor:'#008aff',
          //width:'80%',
        }).then(() => {
          this.fbAuth();
        });
      }else{
        this.fbAuth()
      }
      
    },
    // FB授权
    fbAuth(){      
      Toast.loading({
        duration: 0, // 持续展示 toast
        // forbidClick: true,
        closeOnClick:true,
        icon: require('../../../assets/img/loading.gif'),
        className: 'loading'
      });
      if(!_self.sdkSuccess){
        // console.log("Facebook,sdk 加载失败了，，，重新加载")
        _self.loadFacebookSDK(()=>{
          console.log("成功了~~~~~")
          // api加载完成后，调用FB.login
          Toast.clear();
          _self.FbSdkLogin();
        },()=>{
          // 失败了，
          console.log("失败了~~~~~")
          Toast(this.$t('m.netword_busy_try'));
        });
        return;
      }
      Toast.clear();
      _self.FbSdkLogin();
    },
    FbSdkLogin(){      
      window.FB.login(response => {
        // this.$emit(response.authResponse ? 'success' : 'error', response)
        if(response.authResponse){
          _self.onSignInSuccess(response);
        }else{
          _self.onSignInError(response);
        }
      }, this.fbSignInParams)
    },
    onSignInSuccess(response) {
      console.log(response) //返回第三方的登录信息 token等
      if(response.status=="connected"){
        _self.authResponse = response.authResponse;
        _self.goPostLogin();
      }
    },
    onSignInError (error) {
      _self.authResponse = {};
      //登录失败回调
      console.log(error);
      // Dialog.alert({
      //       message: this.$t('form.auth_fail_confirm_auth'),
      //       confirmButtonColor:'#008AFF',
      //       confirmButtonText:this.$t('m.ok')
      //   }).then(() => {
      //   // on close
      //   });
    },
    goPostLogin(){
      /* this.$store.commit("confirmLogin", {
        "type": 7,
        "uid": _self.authResponse.userID,
        "accessToken": _self.authResponse.accessToken
      }); */
      
      this.confirmLogin(7,{
        "uid":_self.authResponse.userID,
        "accessToken":_self.authResponse.accessToken
      });
    },
  },
};
</script>
<style scoped>
.login_icon {
  width: 0.46rem;
  height: 0.46rem;
  position: absolute;
  top: 0.25rem;
  left: 0.5rem;
}
.login-btn {
  width: 100%;
  height: 0.96rem;
  font-size: 0.3rem;
  line-height: 0.96rem;
  background-color: #008aff;
  position: relative;
  text-align: center;
  color: #fff;
  border-radius: 0.96rem;
  margin-bottom: 0.45rem;
  box-sizing: border-box;
}
.login-btn-white {
  background-color: #fff;
  color: #333;
  box-shadow: 0 0.01rem 0.25rem 0 rgba(11, 79, 218, 0.13);
}
.img_box {
  margin: 0 0.15rem;
}
.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
.fr .login-btn{
  padding: 0 0.3rem 0 1rem;
}
</style>




// WEBPACK FOOTER //
// src/components/Login/LoginSdk/LoginSdkFacebook.vue